import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"


import { Button } from "@/components/Button/Button.tsx"
import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { ProjectNameFormModel } from "@/components/Chat/NewProject/ProjectNameFormModel.ts"
import { useModel } from "@/hooks/useModel.ts"
import { useOrgContext } from "@/hooks/useRootContext.ts"


import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"


export const ProjectNameFormMessage = observer((props: {
  taskId: string
  content: AiChatMessageContent.InitProject.ProjectNameForm
  isActive: boolean
}) => {
  const context = useOrgContext()

  const model = useModel(() => {
    return props.content.suggestedName ? new ProjectNameFormModel(props.taskId, props.content.suggestedName, context) : null
  }, [props.content.suggestedName, props.taskId])

  if (!model) {
    return null
  }

  return (
    <AgentMessageContainer isActive={props.isActive}>
      <ProjectNameSubmitButton kind="primary" onClick={() => model.submit()}>
        {model.text.get()}
      </ProjectNameSubmitButton>
    </AgentMessageContainer>
  )
})

const ProjectNameSubmitButton = styled(Button)`
  justify-self: flex-end;
`